// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonExportWarning_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM17.771 15.3886L19.7292 14.75V19.6456H17.771V15.3886ZM17.771 20.6246H19.7292V22.5828H17.771V20.6246Z" fill="#FDCA40"/>
  <path d="M17.77 15.3886 19.7282 14.75V19.6456H17.77V15.3886ZM17.77 20.6246H19.7282V22.5828H17.77V20.6246Z" fill="#1A2329"/>
  <path d="M17.9998 3L23.9998 7L17.9998 11V8.26064C15.5026 8.26354 13.2689 9.86382 11.9998 12.0619C11.9168 12.2057 11.8392 12.3526 11.7683 12.5C11.7143 11.304 11.9907 10.0777 12.6338 8.96386C13.7895 6.96216 16.0016 5.76336 17.9998 5.71823V3Z" class="svg-bg"/>
  <path d="M12.4782 6H0V21H11.8559C11.6495 20.3671 11.5278 19.696 11.5042 19H2V8H10.8808L10.9017 7.96359C11.3305 7.22098 11.8676 6.563 12.4782 6Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonExportWarning is a generated icon component.
 */
let IconCommonExportWarning = IconCommonExportWarning_1 = class IconCommonExportWarning extends IconBaseElement {
    render() {
        return html `${IconCommonExportWarning_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonExportWarning.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonExportWarning = IconCommonExportWarning_1 = __decorate([
    customElement('zui-icon-common-export-warning')
], IconCommonExportWarning);
export { IconCommonExportWarning };
